export default {
  lang: { fr: "Français", en: "English", it: "Italiano", ar: "العربية" },
  common: {
    loading: "Caricamento…",
    size: "Taglia",
    sizeX: "Taglia {{size}} × {{n}}",
    subtotal: "Subtotale",
    delivery: "Consegna",
    free: "Offerta",
    total: "Totale",
    backToShop: "Torna alla boutique",
    discoverShop: "Scopri la boutique",
    added: "{{name}} aggiunto al carrello",
    quickAdd: "Aggiunta rapida",
    pieces1: "{{n}} capo",
    piecesN: "{{n}} capi",
  },
  sizes: { custom: "Su Misura", onesize: "Unica", years: "{{n}} anni" },
  nav: { man: "Uomo", woman: "Donna", couple: "Set di Coppia", kids: "Bambini", leather: "Pelletteria", essayage: "Prova IA", maison: "La Casa", surmesure: "Su Misura" },
  tryon: {
    eyebrow: "L'Esperienza B.KOSS",
    titlePre: "Prova",
    titleIt: "Virtuale",
    intro: "Componi il tuo outfit, carica la tua foto e la nostra intelligenza artificiale ti veste in tre viste — frontale, profilo, schiena — prima ancora di ordinare.",
    step1: "Passo 01",
    tenueTitle: "Il tuo outfit",
    emptyTenue: "Nessun capo selezionato — sfoglia il catalogo qui sotto o usa il pulsante « Prova » sui capi.",
    all: "Tutti",
    maxPieces: "Fino a 4 capi per outfit",
    clear: "Rimuovi tutto",
    step2: "Passo 02",
    photoTitle: "La tua foto",
    tip1: "Foto frontale, corpo intero visibile",
    tip2: "Ben illuminata, meglio luce naturale",
    tip3: "Abito neutro, sfondo semplice",
    upload: "Carica la mia foto",
    retake: "Cambia foto",
    photoOk: "Foto ricevuta",
    errPhoto: "Foto non valida — scatta una foto frontale ben illuminata (JPG/PNG, max 10 MB)",
    consent: "Accetto che la mia foto sia utilizzata solo per generare questa prova virtuale e venga eliminata automaticamente entro 24 ore.",
    needConsent: "Accetta l'utilizzo della tua foto per continuare",
    generate: "Genera la mia prova",
    generating: "I nostri atelier digitali vestono la tua silhouette…",
    progress: "{{n}}/3 viste preparate",
    viewHint: "Trascina per ruotare a 360°",
    resultEyebrow: "La tua prova",
    resultTitle: "L'outfit ti sta",
    download: "Scarica",
    share: "Condividi",
    shareText: "La mia prova virtuale B.KOSS — Il Marchio dei Grandi Uomini",
    addToCart: "Aggiungi l'outfit al carrello",
    addedCart: "Outfit aggiunto al carrello",
    modify: "Modifica la selezione",
    report: "Segnala un problema",
    errDaily: "Le tue prove gratuite di oggi sono esaurite — prenota un appuntamento in atelier per una prova privata",
    errGeneric: "Generazione impossibile — controlla la tua foto (frontale, ben illuminata) e riprova",
    tried: "{{name}} aggiunto alla tua prova",
    footerNote: "Ogni prova è un'interpretazione digitale — per una prova privata con i nostri maestri sarti, prenota un appuntamento in atelier.",
    shopCta: "Vedi la boutique",
    videoButton: "Film 360°",
    videoBusy: "Il nostro studio sta girando la tua silhouette…",
    videoHint: "Film generato dall'IA — conta 2-4 minuti",
    videoError: "Impossibile generare il film — riprova",
    backToViews: "Torna alle immagini",
  },
  header: {
    slogan: "Il Marchio dei Grandi Uomini",
    openMenu: "Apri il menu",
    closeMenu: "Chiudi il menu",
    openCart: "Apri il carrello",
    city: "Abidjan — Costa d'Avorio",
    lang: "Lingua",
  },
  footer: {
    description: "Casa di moda nata ad Abidjan. Prêt-à-porter d'eccezione, su misura e accessori forgiati per chi lascia il segno della propria epoca.",
    emailPh: "Il tuo indirizzo e-mail",
    join: "Unisciti",
    circle: "Il Circolo B.KOSS — le nostre collezioni in anteprima",
    shopCol: "Boutique",
    catCouple: "Set di Coppia",
    catLeather: "Pelletteria & Accessori",
    allPieces: "Tutti i capi",
    presse: "Stampa & Saloni",
    maisonCol: "La Casa",
    addr1: "Riviera Jardin, di fronte al Groupe Scolaire Les Jasmins",
    addr2: "Cocody — Abidjan, Costa d'Avorio",
    rights: "Tutti i diritti riservati",
    nlOk: "Iscrizione confermata",
    nlOkDesc: "Riceverai le nostre collezioni in anteprima.",
    nlErr: "Iscrizione impossibile — verifica il tuo indirizzo.",
  },
  marquee: { m1: "Il Marchio dei Grandi Uomini", m2: "Abidjan", m3: "Alta Moda", m4: "Su Misura", m5: "Costa d'Avorio", m6: "Dall'Atelier" },
  home: {
    heroEyebrow: "Casa di moda — Abidjan, Costa d'Avorio",
    t1: "Il Marchio",
    t2pre: "dei",
    t2it: "Grandi",
    t3: "Uomini",
    heroText: "Alta sartoria forgiata ad Abidjan. Prêt-à-porter, su misura e accessori per chi lascia il proprio segno al passaggio.",
    ctaCollection: "Scopri la collezione",
    ctaSurmesure: "Il su misura",
    scroll: "Scorri",
    videoCard: "Éburnie — L'insieme iconico",
    soundOn: "Attiva il suono del film",
    soundOff: "Disattiva il suono del film",
    colEyebrow: "Le Collezioni",
    colPre: "Scegli la tua",
    colIt: "categoria",
    viewAll: "Tutti i capi",
    bentoManSub: "{{n}} capi — Camicie, polo, tuniche, pantaloni",
    bentoWomanSub: "{{n}} capi — Eleganza sovrana",
    bentoCoupleSub: "{{n}} capi — Complicità assortita",
    bentoKidsSub: "{{n}} capi — I Grandi di domani",
    bentoLeatherSub: "{{n}} capi — Il dettaglio che firma",
    atelierEyebrow: "L'Atelier",
    atelierTitle: "Il Su Misura",
    atelierText: "Un capo tagliato per te solo, nelle mani dei nostri maestri sarti di Abidjan.",
    bookRdv: "Prendi appuntamento",
    spotEyebrow: "Il capo del mese",
    viewPiece: "Vedi il capo",
    maisonEyebrow: "La Casa",
    maisonPre: "Nata ad Abidjan,",
    maisonIt: "indossata dal mondo",
    maisonText: "Da Cocody ai saloni internazionali, B.KOSS porta la sartoria ivoriana dove non la si aspettava. Unica marca africana al 98° salone internazionale della pelletteria EXPORIVASCHUH GADABAGS in Italia nel 2023, invitata al salone NY NOW a New York lo stesso anno — la Casa scrive il lusso con i propri segni.",
    c1Sub: "Casa madre",
    c2Sub: "EXPORIVASCHUH '23",
    c3Sub: "NY NOW '23",
    maisonCta: "Scopri la Casa",
    bandEyebrow: "Su appuntamento",
    bandPre: "La tua silhouette,",
    bandIt: "tagliata per durare",
    bandCta: "Prendi appuntamento",
    newsEyebrow: "Novità",
    newsPre: "Ultimi",
    newsIt: "arrivi",
  },
  boutique: {
    eyebrow: "La Boutique",
    allPre: "Tutti",
    allPost: "i capi",
    allTitle: "Tutti i capi",
    filterAll: "Tutti",
    sortNew: "Novità",
    sortAsc: "Prezzo crescente",
    sortDesc: "Prezzo decrescente",
    families: "Famiglie:",
    empty: "Nessun capo in questa categoria per il momento.",
  },
  product: {
    notFound: "Questo capo è introvabile.",
    backLink: "La Boutique",
    size: "Taglia",
    qtyMinus: "Riduci la quantità",
    qtyPlus: "Aumenta la quantità",
    addToCart: "Aggiungi al carrello — {{price}}",
    info1: "Consegna espressa offerta ad Abidjan (24–48h). Spedizione internazionale tracciata.",
    info2: "Pagamento Mobile Money sicuro — Wave, Orange, MTN, Moov.",
    info3: "Ritocchi gratuiti in boutique. Garanzia di vestibilità a vita.",
    craft: "Saper Fare",
    craftText: "{{fabric}}. Ogni capo passa per le mani dei nostri maestri sarti nell'atelier B.KOSS di Riviera Jardin, Cocody. Finiture a mano, controlli pezzo per pezzo, monogramma tessuto.",
    customAcc: "Il Su Misura",
    customText: "Questo capo esiste anche sulle tue misure. Prendi appuntamento con l'atelier: rilevazione delle misure, scelta dei tessuti, due prove, consegna entro tre settimane.",
  },
  cart: {
    title: "Il tuo Carrello",
    empty: "Il tuo carrello è vuoto.",
    checkout: "Vai all'ordine",
    momoNote: "Mobile Money — Wave · Orange · MTN · Moov",
    remove: "Rimuovi {{name}}",
    decrease: "Riduci",
    increase: "Aumenta",
  },
  checkout: {
    eyebrow: "Finalizza",
    pre: "Il tuo",
    it: "ordine",
    s1: "I. I tuoi dati",
    fullName: "Nome completo",
    email: "E-mail",
    phone: "Telefono",
    country: "Paese",
    city: "Città",
    address: "Indirizzo di consegna",
    note: "Nota per l'atelier (facoltativo)",
    phName: "Koffi Adjamé",
    phEmail: "tu@esempio.com",
    phPhone: "+225 07 00 00 02 12",
    phCity: "Abidjan",
    phAddress: "Riviera Jardin, Cocody…",
    phMomo: "07 00 00 02 12",
    countryCi: "Costa d'Avorio",
    countryFr: "Francia",
    countryUs: "Stati Uniti",
    countryOther: "Altro",
    s2: "II. Pagamento",
    momoTitle: "Mobile Money",
    momoVia: "— tramite NicePay",
    momoSub: "Ricevi una richiesta di pagamento sul telefono e conferma con il tuo codice segreto.",
    operator: "Operatore",
    momoPhone: "Numero Mobile Money",
    cardTitle: "Carta di credito",
    cardVia: "— sicuro tramite Stripe",
    cardSub: "Visa, Mastercard… Importi convertiti da FCFA a parità fissa (1 € = 655,957 FCFA).",
    codTitle: "Pagamento alla consegna",
    codSub: "Paga il tuo ordine alla ricezione, in contanti o con Mobile Money.",
    recap: "Riepilogo",
    momoErr: "Indica il numero Mobile Money da addebitare.",
    orderErr: "Impossibile registrare l'ordine.",
    confirming: "Conferma…",
    submit: "Conferma l'ordine",
    secure: "Pagamento sicuro — Autenticità garantita",
  },
  confirmation: {
    paidTitle: "Grazie.",
    pendingTitle: "Ordine registrato.",
    ref: "Riferimento",
    simBadge: "Modalità simulazione — pagamenti Mobile Money reali all'attivazione dell'account mercantile NicePay",
    cardPending: "Pagamento con carta in attesa di conferma Stripe — questa pagina si aggiorna automaticamente.",
    momoSim: "Richiesta di pagamento Mobile Money simulata: riceveresti una notifica sul telefono. Conferma con il tuo codice segreto.",
    validated: "Ho confermato il pagamento",
    payNow: "Paga ora — Mobile Money",
    verifying: "Verifica…",
    payOk: "Pagamento confermato. Grazie.",
    payPending: "Pagamento sempre in attesa di convalida.",
    payErr: "Impossibile verificare il pagamento.",
    notFound: "Ordine introvabile.",
    deliveryNote: "Consegna espressa entro 24–48h ad Abidjan",
    continue: "Continua gli acquisti",
  },
  maison: {
    heroEyebrow: "La Casa B.KOSS",
    heroPre: "L'eredità",
    heroIt: "di Abidjan",
    storyTitlePre: "La sartoria come",
    storyTitleIt: "lingua madre",
    story1: "B.KOSS è nata ad Abidjan, tra i filari di tessuti dell'atelier di Riviera Jardin e i grattacieli del Plateau. La Casa veste chi costruisce, decide, brilla — i Grandi Uomini e le Grandi Donne della loro epoca.",
    story2: "Riconosciuta ben oltre i confini ivoriani, la Casa è stata l'unica marca africana al 98° salone internazionale della pelletteria EXPORIVASCHUH GADABAGS in Italia nel 2023, prima di essere invitata al salone NY NOW a New York. Ogni capo resta comunque forgiato qui, a Cocody, dalle mani dei nostri maestri sarti.",
    quote: "« Il lusso non è avere tutto. È essere unici. »",
    valEyebrow: "I Nostri Impegni",
    valPre: "Il gesto perfetto, senza",
    valIt: "compromessi",
    v1t: "Il Su Misura",
    v1d: "Rilevazione delle misure, scelta dei tessuti, due prove: il tuo capo appartiene solo a te.",
    v2t: "Ricamo a Mano",
    v2d: "Motivi baoulé in filo d'oro, eseguiti ad ago dai nostri ricamatori a Cocody.",
    v3t: "Materie Nobili",
    v3d: "Lani freddi, sete duchessa, pelli pieno fiore — selezionate senza compromessi.",
    rdvEyebrow: "Appuntamenti",
    rdvPre: "Prendi appuntamento",
    rdvIt: "in atelier",
    rdvText: "Su misura, ritocchi o consulenza d'immagine: ti aspettiamo nel nostro salone privato di Riviera Jardin, di fronte al Groupe Scolaire Les Jasmins, Cocody — Abidjan. Aperto dal lunedì al sabato, 9–19.",
    fName: "Nome completo",
    fEmail: "E-mail",
    fPhone: "Telefono",
    fService: "Servizio",
    svc1: "Su misura",
    svc2: "Ritocchi",
    svc3: "Consulenza d'immagine",
    svc4: "Grandi occasioni",
    fDate: "Data desiderata",
    fProject: "Il tuo progetto (facoltativo)",
    sending: "Invio…",
    submit: "Richiedi il mio appuntamento",
    ok: "Richiesta inviata — riferimento {{ref}}",
    okDesc: "L'atelier ti richiamerà entro 24h per confermare.",
    err: "Invio impossibile — verifica le tue informazioni.",
  },
  presse: {
    eyebrow: "Stampa & Saloni",
    pre: "La Casa",
    it: "sul davanti",
    intro: "Nata ad Abidjan, B.KOSS porta la sartoria ivoriana sulle più grandi scene internazionali della moda e della pelletteria. Due appuntamenti principali hanno segnato il 2023 della Casa.",
    milanCity: "Milano — Italia",
    milanEdition: "98ª edizione · Gennaio 2023",
    milanP1: "A gennaio 2023, B.KOSS varcava per la prima volta i cancelli di un salone internazionale della pelletteria: la 98ª edizione dell'EXPORIVASCHUH GADABAGS, in Italia. Una prima per la Casa — e una prima per il continente: B.KOSS era l'unica marca africana presente.",
    milanP2: "Borse, portafogli e accessori da viaggio in pelle di alta gamma sono stati presentati agli acquirenti di tutto il mondo, accanto alle grandi case del settore.",
    milanQ1: "Il nostro stand ha attratto numerosi visitatori, interessati ai nostri capi.",
    milanQ2: "Gli acquirenti sono rimasti colpiti dalla qualità dei nostri prodotti e dal nostro impegno verso materiali di alta gamma e un savoir-faire eccezionale.",
    nyCity: "New York — Stati Uniti",
    nyEdition: "13 – 16 agosto 2023",
    nyP1: "Sei mesi dopo, la Casa prendeva la direzione di New York per il salone NY NOW, uno degli appuntamenti maggiori della moda e del design negli Stati Uniti, dal 13 al 16 agosto 2023.",
    nyP2: "B.KOSS ha presentato i suoi modelli tinti nei colori africani, portando la firma ivoriana nel cuore di Manhattan.",
    nyQ1: "Tutto questo grazie al vostro sostegno. Insieme, riveliamo la moda in modo diverso e affrontiamo sfide ancora più grandi.",
    quoteBy: "La Casa B.KOSS",
    nextPre: "Prossimo passo:",
    nextIt: "il tuo guardaroba",
    cta: "Scopri la collezione",
  },
  errors: { boundary: "Un punto si è scucito.", back: "Torna alla home" },
};
